import { render, staticRenderFns } from "./editcourse.vue?vue&type=template&id=70ca85ce&scoped=true&"
import script from "./editcourse.vue?vue&type=script&lang=js&"
export * from "./editcourse.vue?vue&type=script&lang=js&"
import style0 from "./editcourse.vue?vue&type=style&index=0&id=70ca85ce&lang=scss&scoped=true&"
import style1 from "./editcourse.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ca85ce",
  null
  
)

export default component.exports